export default "__VITE_ASSET__BkAWjMCi__"